import request from '@/utils/request'
const BASE_URL = '/GoodsApply'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  updatestate(id) {
    return request({
      url: BASE_URL + '/UpdateState',
      method: 'post',
      params: { id }
    })
  },
 
}